module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "dedication"
    }
  }, [_c('h1', {
    staticStyle: {
      "font-family": "Arial Bold"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v("Dedication")]), _vm._v(" "), _c('p', [_c('br'), _c('br'), _vm._v("To the power of the Almighty, thank you.")]), _vm._v(" "), _c('p', [_c('br'), _vm._v("You are some piece of work. Leaving me to sit around and wonder what the world is really all about while I suffer. And everyone else suffers. You are some damn piece of work. So thank you for this opportunity to tell you off. Thank you for shutting down the music industry, it did wonders for my sanity. And thank you for "), _c('em', [_vm._v("Light of a New Day")]), _vm._v(", may it scare the living shit out of you. You mock me on a throne of morality and pretend you give a shit about what I think. Screw you, the day I pretended to listen to one of your followers. A lunatic, a fool and a criminal are more fastidious than your antics and your immoral decision to ruin people’s lives for the sake of lesson and torment. Buzz off, you scoundrel. You’re of no help to us. Unless you’re going to bless us, in that case, thank you. Thank you. Thank you. Horse’s arse.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a9da684","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch003.vue
// module id = 69
// module chunks = 0